// const SpinnerSVG = require('../assets/puff.svg');

const Spinner = () => {
    return null//<SpinnerSVG />
}

export default Spinner;